// AuthProvider.js
import React, { createContext, useState, useEffect } from "react";
import { auth, onAuthStateChanged } from "./firebaseConfig";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
        //alert(firebaseUser.uid);
        console.log(firebaseUser);
        console.log("here is not null");
      } else {
        console.log("here is null");
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>
  );
};

export default AuthProvider;
